

















import Enumerable from "linq";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { FormatStructureEditableMixin } from "../mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import MultiFlowLayoutSelector from "../../../../../base/components/system/selectors/MultiFlowLayoutSelector.vue";
import { DomainRegistry } from "../../../../domain";
import {
  FormatPageStructureEditor,
  PaperUtility,
} from "../../../../domain/editableFormat";
import { FormatPageOrderTool } from "./tools";

@Component({
  components: {
    FormatPageOrderTool,
    OptionDropDownSelector,
    MultiFlowLayoutSelector,
  }
})
export default class FormatMultiPageSelector extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  magnification: number = 0.25;
  magnificationOptions: StandardOption<number>[] = Enumerable.from([ 10, 25, 50, 75, 100, 125, 150, 175, 200 ])
    .select(s => new StandardOption<number>(s + "%", s / 100))
    .toArray();
  selectingPages: FormatPageStructureEditor[] = [];

  toPageStyle(value: FormatPageStructureEditor): any {
    const isHorizontal = value.isHorizontal().getValue();
    const image = value.image().getValue();
    return value
      ? {
        width: ((isHorizontal ? image.size.height : image.size.width) * this.magnification) + "px",
        height: ((isHorizontal ? image.size.width : image.size.height) * this.magnification) + "px",
      }
      : null;
  }

  toLayerSource(value: FormatPageStructureEditor): string {
    const layer = value.layer().getValue();
    if (!layer || !layer.imageGuid) {
      return null;
    }
    const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
    const imageSource = layer.formatId
      ? repository.getLayerImageSource(layer.formatId, layer.imageGuid)
      : repository.getTemporaryImageSource(layer.imageGuid);
    return imageSource.source;
  }

  toLayerStyle(value: FormatPageStructureEditor): { left: string, top: string, width: string, height: string } {
    const layer = value.layer().getValue();
    if (!layer || !layer.imageGuid) {
      return null;
    }
    return {
      left: (layer.location.x * this.magnification) + "px",
      top: (layer.location.y * this.magnification) + "px",
      width: (layer.size.width * this.magnification) + "px",
      height: (layer.size.height * this.magnification) + "px",
    };
  }

  toPageLabel(value: FormatPageStructureEditor, index: number): string {
    const size = value.size().getValue();
    const paper = PaperUtility.IPapers[PaperUtility.sizeToKind(size)];
    const isHorizontal = value.isHorizontal().getValue() ? "横" : "縦";
    return (index + 1).toString() + "ページ(" + paper.name + " " + isHorizontal + ")";
  }

  equivalentValidator(source: FormatPageStructureEditor, destination: FormatPageStructureEditor): boolean {
    return source.isReferedSameSource(destination);
  }

  @Watch("selectingPages")
  onSelectingPagesUpdated(newValue: FormatPageStructureEditor[], oldValue: FormatPageStructureEditor[]): void {
    if (newValue.length === oldValue.length && newValue.every((v, i, a) => v.isReferedSameSource(oldValue[i]))) {
      return;
    }
    this.reselectPages(...newValue);
  }

  @Watch("pages")
  onPagesUpdated(newValue: FormatPageStructureEditor[], oldValue: FormatPageStructureEditor[]): void {
    this.selectingPages = this.selectedPages;
  }
}
